"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const CustomDomain = require('../customDomain');
const EventFactory = require('./eventFactory');
const {
  tenants
} = require('./../constants');
const PageSharedPayloadMiddleware = require('../middlewares/pageSharedPayloadMiddleware');

/**
 * Segment analytics.js library is not able to send an event generated during unloading of a page.
 * That's why it was decided to use `navigator.sendBeacon`. An event is constructed manually.
 * A shared payload is a part of Page event, which should be sent earlier.
 */
class TrackingBeacon {
  constructor(writeKey, tenant, culture) {
    _defineProperty(this, "track", (eventName, properties) => {
      const sharedPayload = PageSharedPayloadMiddleware.getPageSharedPayload();
      if (!sharedPayload) {
        return;
      }
      let payload = EventFactory.create(this._writeKey, eventName, {
        properties: _objectSpread(_objectSpread({}, sharedPayload.properties), properties),
        culture: this._culture,
        tenant: this._tenant,
        sharedPayload
      });
      const sentAt = new Date();
      payload = _objectSpread(_objectSpread({}, payload), {}, {
        sentAt
      });
      const blobData = new Blob([JSON.stringify(payload)], {
        type: 'text/plain'
      });
      navigator.sendBeacon(this._segmentTrackUrl, blobData);
    });
    const domainConfig = CustomDomain.getConfig(writeKey);
    this._segmentTrackUrl = this._getSegmentTrackUrl(domainConfig);
    this._writeKey = writeKey;
    this._tenant = tenant || tenants.Vistaprint;
    this._culture = culture || 'en-IE';
  }
  _getSegmentTrackUrl(domainConfig) {
    const apiHost = domainConfig.apiHost ?? 'api.segment.io/v1';
    return `https://${apiHost}/t`;
  }
}
module.exports = TrackingBeacon;